import { render, staticRenderFns } from "./base-textarea.vue?vue&type=template&id=59c30b2f&scoped=true"
import script from "./base-textarea.vue?vue&type=script&setup=true&lang=js"
export * from "./base-textarea.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-textarea.vue?vue&type=style&index=0&id=59c30b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c30b2f",
  null
  
)

export default component.exports